import { Affiliate, AppointmentBooking, Blog, BorrowingPower, BusinessLoanAssetFinance, BusinessLoanCommercial, CarLoan, Chat, CreditScore, FixedRateExpiry, Insurance, Invite, MarketingOther, NewHomeLoan, PropertyReport, Refinance, SelfGen, SignUp, StampDutyCalculator, AussieHomes, AreaReport, } from '../../classes';
import { Origin } from '../../enums';
export var leadStoreGenerator = function () {
    var _a;
    return (_a = {},
        _a[Origin.PropertyReport] = PropertyReport,
        _a[Origin.SignUp] = SignUp,
        _a[Origin.BorrowingPower] = BorrowingPower,
        _a[Origin.NewHomeLoan] = NewHomeLoan,
        _a[Origin.Refinance] = Refinance,
        _a[Origin.Blog] = Blog,
        _a[Origin.StampDutyCalculator] = StampDutyCalculator,
        _a[Origin.AppointmentBooking] = AppointmentBooking,
        _a[Origin.Invite] = Invite,
        _a[Origin.Chat] = Chat,
        _a[Origin.SelfGen] = SelfGen,
        _a[Origin.CreditScore] = CreditScore,
        _a[Origin.FixedRateExpiry] = FixedRateExpiry,
        _a[Origin.AffiliateLead] = Affiliate,
        _a[Origin.MarketingOther] = MarketingOther,
        _a[Origin.CarLoan] = CarLoan,
        _a[Origin.BusinessLoanAssetFinance] = BusinessLoanAssetFinance,
        _a[Origin.BusinessLoanCommercial] = BusinessLoanCommercial,
        _a[Origin.Insurance] = Insurance,
        _a[Origin.AussieHomes] = AussieHomes,
        _a[Origin.AreaReport] = AreaReport,
        _a);
};
//# sourceMappingURL=index.js.map